import api from "./api.js";

export default class AnalyticsApi {
  static async getListAnalytics(params) {
    return await api.get(`api/analytics`, params);
  }

  // 매출
  static async getListOrder(params) {
    return await api.get(`api/analytics/order`, params);
  }

  // 멤버십 분석
  static async getListMembership(params) {
    return await api.get(`api/analytics/membership`, params);
  }

  // 기타 사유 목록 조회
  static async getListEtcReason(params) {
    return await api.get(`api/analytics/membership/cancel/reason`, params);
  }

  // 성별·연령별 조회
  static async getListGenderAge(params) {
    return await api.get(`api/analytics/age/gender`, params);
  }

  // 방문자 or 페이지뷰 조회
  static async getListVisitPageview(params) {
    return await api.get(`api/analytics/visit/pageview`, params);
  }

  // 많이 방문한 페이지 조회
  static async getListMostVisited(params) {
    return await api.get(`api/analytics/most/page`, params);
  }
}
